import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumb bar for logged-in Akademie-Mitglieder, rendered directly below the
 * MemberHeader on every profile page.
 */
const ROUTE_TRAIL = {
    '/portal': [{ label: 'Mein Bereich', icon: Home }],
    '/kontaktdaten': [
        { label: 'Mein Bereich', to: '/portal', icon: Home },
        { label: 'Meine Kontaktdaten' },
    ],
    '/lizenzverlaengerung': [
        { label: 'Mein Bereich', to: '/portal', icon: Home },
        { label: 'Meine Lizenz verlängern' },
    ],
    '/seminare': [
        { label: 'Mein Bereich', to: '/portal', icon: Home },
        { label: 'Seminare' },
    ],
};

export function MemberBreadcrumb({ trail: trailProp }) {
    const { pathname } = useLocation();
    const trail = trailProp || ROUTE_TRAIL[pathname] || ROUTE_TRAIL[Object.keys(ROUTE_TRAIL).find(k => pathname.startsWith(k))] || [];
    if (!trail.length) return null;

    return (
        <nav
            className="bg-gray-100 border-b border-gray-200"
            aria-label="Breadcrumb"
            data-testid="member-breadcrumb"
        >
            <ol className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-1.5 text-xs text-gray-600">
                {trail.map((item, idx) => {
                    const isLast = idx === trail.length - 1;
                    const Icon = item.icon;
                    return (
                        <li key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
                            {idx > 0 && <ChevronRight className="h-3.5 w-3.5 text-gray-400" />}
                            {item.to && !isLast ? (
                                <Link to={item.to} className="hover:text-primary hover:underline flex items-center gap-1">
                                    {Icon && <Icon className="h-3.5 w-3.5" />}
                                    {item.label}
                                </Link>
                            ) : (
                                <span className={`flex items-center gap-1 ${isLast ? 'text-gray-900 font-medium' : ''}`}>
                                    {Icon && <Icon className="h-3.5 w-3.5" />}
                                    {item.label}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}

export default MemberBreadcrumb;
